export default "__VITE_ASSET__BAa3Jfj9__"